import type React from 'react';

export enum TypographyColor {
	Regular = 'REGULAR',
	Secondary = 'SECONDARY',
	Subtle = 'SUBTLE',
	Disabled = 'DISABLED',
	Inverse = 'INVERSE',
	Brand = 'BRAND',
	Danger = 'DANGER',
	Warning = 'WARNING',
	Success = 'SUCCESS'
}

export enum TypographyBodySize {
	Medium = 'MEDIUM',
	Small = 'SMALL'
}

export type TypographyVariant =
	| 'h1'
	| 'h2'
	| 'h3'
	| 'h4'
	| 'h5'
	| 'bodyMedium'
	| 'bodySmall'
	| 'label'
	| 'helper'
	| 'strong';

export type TypographyProps = Omit<React.HTMLAttributes<HTMLElement>, 'style'> & {
	tag?: React.ElementType;
	color?: TypographyColor;
	className?: string;
};

export type TypographyBodyProps = TypographyProps & {
	size?: TypographyBodySize;
};
